import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=5b2e724f&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=5b2e724f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2e724f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseNav: require('/build/components/BaseNav.vue').default})
